<template>
    <div v-if="instLabel">
        <sui-table>
            <sui-table-body>
                <template v-if="apiResponse">
                    <sui-table-row>
                        <sui-table-cell>Equipment id</sui-table-cell>
                        <sui-table-cell>{{apiResponse.equipmentId}}</sui-table-cell>
                    </sui-table-row>
                    <sui-table-row>
                        <sui-table-cell>Type</sui-table-cell>
                        <sui-table-cell>{{apiResponse.type}}</sui-table-cell>
                    </sui-table-row>
                    <sui-table-row>
                        <sui-table-cell>PON-Serienummer</sui-table-cell>
                        <sui-table-cell>{{apiResponse.serialNumber}}</sui-table-cell>
                    </sui-table-row>
                    <sui-table-row>
                        <sui-table-cell>MAC Address</sui-table-cell>
                        <sui-table-cell>{{apiResponse.macAddress}}</sui-table-cell>
                    </sui-table-row>
                </template>
                <template v-if="apiError">
                    <sui-table-row>
                        <sui-table-cell colspan="2" style="color: red;">
                            Fejl ved hentning af PON-boks data: {{apiError.errorObject?.message || 'Ukendt fejl'}}
                        </sui-table-cell>
                    </sui-table-row>
                    <sui-table-row v-if="apiError.errorObject">
                        <sui-table-cell v-if="apiError.errorObject.status == '403'" colspan="2">
                            Fejl 403 betyder at vores API-nøgle ikke har tilladelse til at hente PON-boks data for denne installation.
                        </sui-table-cell>
                        <sui-table-cell v-else-if="apiError.errorObject.status == '404'" colspan="2">
                            Fejl 404 betyder at installationsnummeret ikke blev fundet ikke i databasen.
                        </sui-table-cell>
                        <sui-table-cell v-else-if="apiError.errorObject.status == '500'" colspan="2">
                            Fejl 500 betyder at der er en intern serverfejl hos PilotBI/VirkPlan. Prøv igen senere.
                        </sui-table-cell>
                    </sui-table-row>
                </template>
            </sui-table-body>
        </sui-table>
        <sui-form>
            <div 
                style="display: flex; margin: 10px; gap: 10px; align-items: flex-end;"
            >
                <sui-form-field
                    style="flex: 1;"
                >
                    <sui-input v-model="ponSerialNumber" placeholder="Scan eller indtast serienummer på ny PON-boks her"/>
                </sui-form-field>
                <sui-button
                    style="padding-left: 10px; padding-right: 10px; margin-bottom: 15px;"
                    @click.prevent="scanPonSerialNumber()"
                ><i title="Scan PON-boks serienummer" class="fa-solid fa-barcode-read"></i></sui-button>
            </div>
        </sui-form>
        <div style="display: flex; gap: 10px; margin: 10px; margin-top: -10px;">
            <sui-button :disabled="!ponSerialNumber || (ponActionRunning && selectedPonAction !== 'create')" style="flex: 1;" color="green" :loading="ponActionRunning && selectedPonAction === 'create'" @click="createPonBoxButtonClicked()">Ny PON-boks</sui-button>
            <sui-button :disabled="!ponSerialNumber || (ponActionRunning && selectedPonAction !== 'update')" style="flex: 1;" color="yellow" :loading="ponActionRunning && selectedPonAction === 'update'" @click="replacePonBoxButtonClicked()">Udskift PON-boks</sui-button>
            <sui-button :disabled="ponActionRunning && selectedPonAction !== 'delete'" style="flex: 1;" color="red" :loading="ponActionRunning && selectedPonAction === 'delete'" @click="removePonBoxButtonClicked()">Fjern PON-boks</sui-button>
        </div>
        <barcode-scanner-modal
            :isModalOpen="isBarcodeScannerOpen"
        />
    </div>
</template>

<script>
import { Mixin } from '../../lib/Mixins/mixin'
import { DataAPI } from '../../lib/DataAPI'
import EventBus from '../../EventBus'
import swal from 'sweetalert';
import BarcodeScannerModal from '@/components/Misc/BarcodeScannerModal.vue'

export default {
    mixins: [Mixin, DataAPI],

    components: {
        // TableLoader,
        BarcodeScannerModal,
    },

    props: {
        instLabel: String,
        includeReloadBtn: {
            type: Boolean,
            default: true
        },
    },

    data(){
        return {
            ponBoxLoading: false,
            apiResponse: null,
            apiError: null,
            isBarcodeScannerOpen: false,
            ponActionRunning: false,

            ponSerialNumber: '',
            ponModel: '',

            ontModelOptions: [
                {text: 'FiberTwist XGS2110B', value: 'FT-XGS2110B'},
            ],
        }
    },

    methods: {
        async getPonBox() {
            EventBus.$emit('function-activity', {functionName: 'PonBox_getPonBox', isActive: true})
            this.apiResponse = null
            this.apiError = null
            EventBus.$emit('retrieved-pon-box', {data: 'Henter PON Box...', loading: true})
            if (!this.instLabel) {
                EventBus.$emit('retrieved-pon-box', {data: 'Intet installations-nr', loading: false})
                EventBus.$emit('function-activity', {functionName: 'PonBox_getPonBox', isActive: false})
                return null
            }
            this.ponBoxLoading = true
            try {
                this.apiResponse = await this.dataGetPonBox(this.instLabel)
                EventBus.$emit('retrieved-pon-box', {data: this.apiResponse.id, loading: false})
                this.ponBoxLoading = false
            } catch (error) {
                EventBus.$emit('retrieved-pon-box', {data: 'Kunne ikke hente data!', loading: false})
                this.apiError = error
                console.error(error)
                this.ponBoxLoading = false
            }
            EventBus.$emit('function-activity', {functionName: 'PonBox_getPonBox', isActive: false})
            return this.apiResponse
        },

        scanPonSerialNumber() {
            console.log('Scanning PON-boks serienummer...')
            console.log('Opening barcode scanner...')
            this.isBarcodeScannerOpen = true;
        },

        async performPonAction() {  
            this.ponActionRunning = true

            if (this.selectedPonAction != 'delete' && !this.ponSerialNumber) {
                swal("Fejl", "Indtast venligst et serienummer før du fortsætter.", "error")
                this.ponActionRunning = false
                return
            }

            if (this.selectedPonAction != 'delete') {
                try {

                    if (!/^(ALCL|ICTR|CIGG|GNXS).{8}$/.test(this.ponSerialNumber)) { //Anything not matching this regex will result in error 400 from the create/update API endpoint
                        swal("Fejl", `Serienummeret ${this.ponSerialNumber} er ugyldigt.\nVær opmærksom på store og små bogstaver.`, "error");
                        this.ponActionRunning = false;
                        return;
                    }

                    const response = await this.dataPonboxIsWhitelisted(this.ponSerialNumber);
    
                    if (!response.isWhiteListed) {
                        swal("Fejl", `Serienummeret ${this.ponSerialNumber} er ikke whitelisted til brug.\nVær opmærksom på store og små bogstaver.`, "error");
                        this.ponActionRunning = false;
                        return;
                    }
    
                    if (response?.type && this.ontModelOptions.some(option => option.value === response.type)) {
                        this.ponModel = response.type
                    }
    
                } catch (error) {
                    console.error('Error checking if serial is whitelisted:', error);
                    swal("Fejl", `Der opstod en fejl under validering af serienummer: ${error.message}`, "error");
                    this.ponActionRunning = false;
                    return;
                }

                if (!this.ponModel && this.ontModelOptions.length == 1) {
                    this.ponModel = this.ontModelOptions[0].value
                }
            }

            if (this.selectedPonAction != 'delete' && !this.ponModel) {
                swal("Fejl", "Vælg venligst en PON-boks model før du fortsætter.", "error")
                this.ponActionRunning = false
                return
            }
            if (!this.instLabel) {
                swal("Fejl", "Manglende installations-label. Genindlæs venligst siden og prøv igen.", "error")
                this.ponActionRunning = false
                return
            }
            
            switch (this.selectedPonAction) {
                case 'create':
                    console.log(`Creating new PON-boks with serial number ${this.ponSerialNumber} and model ${this.ponModel}...`)
                    try {
                        await this.dataPostPonbox(this.instLabel, this.ponModel, this.ponSerialNumber);
                        swal("Succes", "PON-boks oprettet succesfuldt.", "success");
                    } catch (error) {
                        console.error('Error creating PON-boks:', error);
                        swal("Fejl", `Der opstod en fejl under oprettelse af PON-boks: ${error.message}`, "error");
                        this.ponActionRunning = false;
                        return;
                    }
                    break;
                case 'update':
                    console.log(`Updating existing PON-boks to serial number ${this.ponSerialNumber} and model ${this.ponModel}...`)
                    try {
                        await this.dataUpdatePonbox(this.instLabel, this.ponModel, this.ponSerialNumber);
                        swal("Succes", "PON-boks opdateret succesfuldt.", "success");
                    } catch (error) {
                        console.error('Error updating PON-boks:', error);
                        swal("Fejl", `Der opstod en fejl under opdatering af PON-boks: ${error.message}`, "error");
                        this.ponActionRunning = false;
                        return;
                    }
                    break;
                case 'delete':
                    console.log(`Deleting existing PON-boks...`)
                    try {
                        await this.dataDeletePonbox(this.instLabel);
                        swal("Succes", "PON-boks fjernet succesfuldt.", "success");
                    } catch (error) {
                        console.error('Error deleting PON-boks:', error);
                        swal("Fejl", `Der opstod en fejl under sletning af PON-boks: ${error.message}`, "error");
                        this.ponActionRunning = false;
                        return;
                    }
                    break;
            }

            this.ponActionRunning = false;
        },



        async createPonBoxButtonClicked() {
            this.selectedPonAction = 'create';
            this.performPonAction();
        },

        async replacePonBoxButtonClicked() {
            this.selectedPonAction = 'update';
            this.performPonAction();
        },

        async removePonBoxButtonClicked() {
            await swal({
                title: 'Er du sikker?',
                text: `Du er ved at fjerne PON-boksen fra installation ${this.instLabel}. Dette kan ikke fortrydes!`,
                icon: 'warning',
                buttons: true,
                dangerMode: true,
            }).then(async (willDelete) => {
                if (willDelete) {
                    this.selectedPonAction = 'delete';
                    this.performPonAction();
                }
            });
        },
    },

    mounted() {
        EventBus.$on('reload-pon-box-click', () => {this.getPonBox()})

        EventBus.$on('barcode-scanner-modal-closing', () => {this.isBarcodeScannerOpen = false})
        EventBus.$on('scanned-barcode-data', (data) => {
            if (this.isBarcodeScannerOpen) {
                console.log('Received scanned barcode data:', data);
                this.ponSerialNumber = data.serial;

                if (data?.type && this.ontModelOptions.some(option => option.value === data.type)) {
                    this.ponModel = data.type
                }
            }
        })
    },

    beforeDestroy() {
        EventBus.$off('reload-pon-box-click')
        EventBus.$off('barcode-scanner-modal-closing')
        EventBus.$off('scanned-barcode-data')
    },

    watch: {
        instLabel: {
            immediate: true,
            handler() {
                this.getPonBox()
                this.ponSerialNumber = ''
                this.ponModel = ''
            }
        },
    }
}
</script>
<style scoped>
    .signalInRange{
        color: green;
        font-weight: bold;
    }
    .signalOutOfRange{
        color: red;
        font-weight: bold;
    }
</style>